import React from "react";
import { Doughnut, HorizontalBar } from "react-chartjs-2";
import _ from "lodash";
import { doughnutOptions } from "./_commonSharedChartOptions";
import { connect } from "react-redux";
import { setColor } from "../../../../views/Dashboard/dashboard/ColorPalette";
import { WidgetNoDataToDisplay, WidgetServerError } from "../../../../components/DashboardWidget/WidgetCommon";
import { lexPlatformUsageDataPreview } from "./_previewData";
import "chartjs-plugin-datalabels";
import { usageByConnectorHeader } from "./_detailsTableHeaders";

const config_default = {
  Chart: "CONNECTOR_TASK_USAGE",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

const widgetDetails = {
  Chart: "CONNECTOR_TASK_USAGE_DETAILS",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class UsageByConnectorClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, draggable } = this.props;

    return (
      <div>
        <div className="widgetTitle">Requests By Connector</div>
        <div className="widgetBody">
          {draggable ? (
            <WidgetServerError draggable={draggable} />
          ) : widgetData === undefined || draggable ? (
            <WidgetNoDataToDisplay draggable={draggable} />
          ) : (
            <Doughnut
              id="USAGE_BY_CONNECTOR"
              data={{
                labels: this.props.widgetData.labels,
                datasets: [
                  {
                    data: this.props.widgetData.data,
                    backgroundColor: setColor(widgetData.labels)
                  }
                ]
              }}
              options={_.extend({}, doughnutOptions, {
                legend: { position: "right" },
                hover: {
                  onHover: function(e) {
                    let point = this.getElementAtEvent(e);
                    if (point.length) e.target.style.cursor = "pointer";
                    else e.target.style.cursor = "default";
                  }
                }
              })}
            />
          )}
        </div>
      </div>
    );
  }
}

export class UsageByConnectorPreview extends React.Component {
  render() {
    return (
      <div>
        <div className="widgetTitle">Requests By Connector</div>
        <div className="widgetBody">
          <Doughnut
            id="USAGE_BY_CONNECTOR"
            data={lexPlatformUsageDataPreview}
            options={_.merge({}, doughnutOptions, {
              legend: {
                position: "right",
                labels: {
                  fontSize: 8
                }
              },
              plugins: {
                datalabels: {
                  font: {
                    size: 7
                  }
                }
              }
            })}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard.data["ConnectorsRequest"]
  };
}

export const UsageByConnectorContent = connect(
  mapStateToProps,
  undefined
)(UsageByConnectorClass);
